import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { Clickable, Icon, Layout, Text } from 'ds';
import { AI_ASSISTANT_PATH } from 'routes';
import { actions } from 'store/AIAssistant';
import { useAppSelector } from 'store/hooks';
import { selectTenancyId } from 'store/v2/User/selectors';

import { postToConversation, startConversation } from './requests';

interface AIAssistantPromptSuggestionCardProps {
  prompt: string;
  setIsExitAnimationActive: (showExitAnimation: boolean) => void;
  paddingLeft?: number;
  paddingRight?: number;
}

const AIAssistantPromptSuggestionCard: React.FC<AIAssistantPromptSuggestionCardProps> = ({
  prompt,
  setIsExitAnimationActive,
  paddingLeft = 0,
  paddingRight = 0
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const tenancyId = useAppSelector(selectTenancyId);

  if (!tenancyId) return null;

  const handleMessage = async ({ conversationId, input }: { conversationId: number; input: string }) => {
    const { data: conversation } = await postToConversation({
      tenancyId,
      conversationId: conversationId,
      message: input
    });
    dispatch(actions.removePendingConversationMessage({ conversationId }));
    dispatch(actions.updateConversation({ conversation }));
    dispatch(actions.setRequestStateForConversation({ conversationId, requestState: 'ready' }));
  };

  const handlePromptCardClick = async () => {
    dispatch(actions.setNewConversationRequestState('in_progress'));
    setIsExitAnimationActive(true);
    const { data } = await startConversation(tenancyId);
    dispatch(actions.setRequestStateForConversation({ conversationId: data.id, requestState: 'in_progress' }));
    dispatch(actions.addConversation(data));
    dispatch(actions.addPendingConversationMessage({ conversationId: data.id, input: prompt }));
    handleMessage({ conversationId: data.id, input: prompt });

    setTimeout(() => {
      history.push(`${AI_ASSISTANT_PATH}/${data.id}`);
      dispatch(actions.setNewConversationRequestState('ready'));
      setIsExitAnimationActive?.(false);
    }, 700);
  };

  return (
    <Layout
      className="ai-assistant-suggestion-pill"
      onMouseDown={event => event.preventDefault()}
      style={{ height: 'fit-content', paddingLeft, paddingRight }}
    >
      <Clickable onClick={handlePromptCardClick} style={{ height: 'fit-content' }}>
        <Layout
          height={40}
          width="fit-content"
          borderRadius={1000}
          color="purple-gradient-transparent"
          paddingY={8}
          paddingLeft={12}
          paddingRight={20}
          hoverColor="gray-25"
        >
          <Layout flex direction="row" gap={4} align="center">
            <Icon name="sparkle" size={24} color="purple-gradient" />
            <Text size="body-sm" semibold color="purple-gradient" wrap={false}>
              {prompt}
            </Text>
          </Layout>
        </Layout>
      </Clickable>
    </Layout>
  );
};

export default AIAssistantPromptSuggestionCard;
